import type { BuildPanelBucket } from './buildApi';

export interface PanelSplit {
  panel_bucket: BuildPanelBucket;
  serken_percent?: number;
}

export function validSerkenPercent(value: unknown): value is number {
  return typeof value === 'number' && Number.isInteger(value) && value >= 0 && value <= 100;
}

export function panelSplitLabel(split: PanelSplit): string {
  if (split.panel_bucket === 'serken') return '100% Serken';
  if (split.panel_bucket === 'regular') return '100% regular';
  const percent = split.serken_percent ?? 50;
  return `${percent}% Serken / ${100 - percent}% regular`;
}

/** Mirrors panelKindAt in src/lib/build/panel-split.ts; covered by parity tests.
 * Domain insertion order matches the server's rosterDomains, not the sorted
 * domain list used elsewhere in the wizard. Count actual inboxes even when
 * domains have different mailbox counts. */
export function previewPanelSplit(rows: readonly { email: string }[], split: PanelSplit) {
  const percent = split.panel_bucket === 'serken' ? 100
    : split.panel_bucket === 'regular' ? 0 : split.serken_percent ?? 50;
  if (!validSerkenPercent(percent)) return null;
  const domains = new Map<string, number>();
  for (const row of rows) {
    const domain = row.email.split('@')[1];
    if (domain) domains.set(domain, (domains.get(domain) ?? 0) + 1);
  }
  const totals = { serken: { domains: 0, inboxes: 0 }, regular: { domains: 0, inboxes: 0 } };
  let position = 0;
  for (const inboxes of domains.values()) {
    const kind = Math.floor(((position + 1) * percent + 50) / 100)
      > Math.floor((position * percent + 50) / 100) ? 'serken' : 'regular';
    totals[kind].domains++;
    totals[kind].inboxes += inboxes;
    position++;
  }
  return totals;
}
